// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VkKC5","right":"styles_right__3rQL-"};